export default {
  placeholder: 'Vybrať schému zakladania',
};
